/* eslint-disable camelcase */

import React, { useState } from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import Media from 'react-media';

import BulmaDropdown from 'react-bulma-components/lib/components/dropdown';
import {
  StyledTagNavContainer,
  StyledTagNavUl,
  styledTagNavItem,
  StyledSpan,
  StyledTagNavContainerMobile,
} from './TagNavStyles';

import { LazyLink } from '../../../slices/atoms';

const query = graphql`
  query {
    prismic {
      allTags {
        edges {
          node {
            _meta {
              uid
            }
            tag
            _linkType
          }
        }
      }
    }
  }
`;

// active style
const activeTagNav = {
  background: '#f2f8ff',
  borderRadius: '40px',
  color: '#0069ff',
};

const RenderTagNav = (data, { uid, hideOnMobile }) => {
  const tags = data.prismic.allTags.edges;

  let selected;
  if (uid && uid.includes('-')) {
    selected = uid.replace(/(\w*)-(\w*)/g, '$1 $2');
  } else if (uid && uid.includes('_')) {
    selected = uid.replace(/(\w*)_(\w*)/g, '$1 $2');
  } else if (uid) {
    selected = uid;
  } else {
    selected = 'All Topics';
  }

  // This is used to enable defaultMatches for react-media Media SSR issues
  const [isMedia] = useState('mobile');
  return (
    <>
      <Media
        queries={{ medium: '(max-width: 1024px)' }}
        defaultMatches={{ medium: isMedia === 'mobile' }}
        render={() => (
          <StyledTagNavContainerMobile>
            <BulmaDropdown className={hideOnMobile}>
              <BulmaDropdown.Item style={{ display: 'none' }} value={selected}>
                {selected}
              </BulmaDropdown.Item>
              <BulmaDropdown.Item renderAs="a" href="/blog/" value="All Topics">
                All Topics
              </BulmaDropdown.Item>
              {tags.map(tag => (
                <BulmaDropdown.Item
                  key={tag.node.tag}
                  renderAs={LazyLink}
                  url={`https://digitalocean.com/blog/tag/${tag.node._meta.uid}`}
                  label={tag.node.tag}
                  value={tag.node.tag}
                >
                  {tag.node.tag}
                </BulmaDropdown.Item>
              ))}
            </BulmaDropdown>
          </StyledTagNavContainerMobile>
        )}
      />

      <Media
        queries={{ medium: '(min-width: 1025px)' }}
        defaultMatches={{ medium: isMedia === 'desktop' }}
        render={() => (
          <StyledTagNavContainer>
            <StyledTagNavUl>
              <StyledSpan>Topics</StyledSpan>
              <li key="all">
                <Link activeStyle={activeTagNav} css={styledTagNavItem} to="/blog/">
                  All
                </Link>
              </li>
              {tags.map(tag => (
                <li key={tag.node.tag}>
                  <Link
                    activeStyle={activeTagNav}
                    partiallyActive
                    css={styledTagNavItem}
                    to={`blog/tag/${tag.node._meta.uid}`}
                    key={`${tag.node.uid}`}
                  >
                    {tag.node.tag}
                  </Link>
                </li>
              ))}
            </StyledTagNavUl>
          </StyledTagNavContainer>
        )}
      />
    </>
  );
};

const TagNav = (uid, hideOnMobile) => (
  <StaticQuery query={`${query}`} render={data => RenderTagNav(data, { uid, hideOnMobile })} />
);

export default TagNav;
